/**
 * API Configuration
 *
 * Central configuration for API endpoints and settings.
 */

// Base URL configuration with fallback
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// API version prefix
export const API_VERSION = '/api/v1';

// Full API URL (empty string means use relative URLs with proxy)
export const API_URL = API_BASE_URL ? `${API_BASE_URL}${API_VERSION}` : API_VERSION;

// Token storage keys
export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'agri_access_token',
  REFRESH_TOKEN: 'agri_refresh_token',
  USER: 'agri_user',
} as const;

// API endpoints
export const ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    CHANGE_PASSWORD: '/auth/change-password',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
  },

  // Users
  USERS: '/users',

  // Clients
  CLIENTS: '/clients',

  // Products & Stock
  PRODUCTS: '/products',
  STOCK: '/stock',

  // Sales
  QUOTES: '/quotes',
  INVOICES: '/invoices',
  PAYMENTS: '/payments',
  DELIVERIES: '/deliveries',

  // Contracts
  CONTRACTS: '/contracts',
  LOCATIONS: '/locations',
  LOA: '/loa',

  // Files
  FILES: '/files',

  // Reference Data
  CATEGORIES: '/categories',
  SITES: '/sites',
  PROVENANCES: '/provenances',
  PRODUCT_TYPES: '/product-types',

  // Reporting, Accounting & Admin
  DASHBOARD: '/dashboard',
  REPORTING: '/reporting',
  COMPTABILITE: '/comptabilite',
  ADMIN: '/admin',

  // Health
  HEALTH: '/health',
} as const;

// Request timeout in milliseconds
export const REQUEST_TIMEOUT = 30000;

// File upload limits
export const UPLOAD_LIMITS = {
  MAX_SIZE_MB: 10,
  MAX_SIZE_BYTES: 10 * 1024 * 1024,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf'],
} as const;

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
} as const;
